export type IcPaginationItemType = "page" | "ellipsis" | "simple-current";
